function AdminTabs({ activeSection, setActiveSection }) {
  return (
    <nav className="admin-nav">
      <button
        className={`admin-nav-btn ${activeSection === 'inventory' ? 'active' : ''}`}
        onClick={() => setActiveSection('inventory')}
        type="button"
      >
        Manage Inventory
      </button>
      <button
        className={`admin-nav-btn ${activeSection === 'add-vehicle' ? 'active' : ''}`}
        onClick={() => setActiveSection('add-vehicle')}
        type="button"
      >
        Add Vehicle
      </button>
      <button
        className={`admin-nav-btn ${activeSection === 'testimonials' ? 'active' : ''}`}
        onClick={() => setActiveSection('testimonials')}
        type="button"
      >
        Manage Testimonials
      </button>
      <button
        className={`admin-nav-btn ${activeSection === 'users' ? 'active' : ''}`}
        onClick={() => setActiveSection('users')}
        type="button"
      >
        Manage Users
      </button>
    </nav>
  );
}

export default AdminTabs;
